import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Headphones, Menu, X } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
import { Button } from './ui/button';

export const Header = () => {
    const { getCount } = useCart();
    const cartCount = getCount();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const navLinks = [
        { to: '/is-this-for-me', label: 'Is This For Me?', testId: 'nav-is-this-for-me' },
        { to: '/recordings', label: 'Recordings', testId: 'nav-recordings' },
        { to: '/blog', label: 'Blog', testId: 'nav-blog' },
        { to: '/about', label: 'About', testId: 'nav-about' },
    ];

    return (
        <header className="fixed top-0 left-0 right-0 z-50 glass">
            <div className="max-w-7xl mx-auto px-6 py-4">
                <nav className="flex items-center justify-between">
                    <Link 
                        to="/" 
                        className="flex items-center gap-3 group"
                        data-testid="header-logo"
                    >
                        <div className="w-10 h-10 rounded-full bg-nature-800 flex items-center justify-center">
                            <Headphones className="w-5 h-5 text-nature-50" />
                        </div>
                        <div>
                            <span className="font-heading text-lg font-semibold text-nature-900 group-hover:text-copper-500 transition-colors">
                                Hypnosis Mastery Series
                            </span>
                            <span className="hidden sm:block text-xs text-nature-800/60 font-body">
                                Single hypnosis sessions for a mind that won't switch off.
                            </span>
                        </div>
                    </Link>

                    <div className="flex items-center gap-4">
                        {/* Desktop Navigation */}
                        {navLinks.map((link) => (
                            <Link 
                                key={link.to}
                                to={link.to} 
                                className="hidden md:block text-nature-800 hover:text-copper-500 transition-colors font-body font-medium"
                                data-testid={link.testId}
                            >
                                {link.label}
                            </Link>
                        ))}
                        
                        {/* Cart Button */}
                        <Link to="/cart" data-testid="cart-button">
                            <Button 
                                variant="outline" 
                                size="sm"
                                className="relative rounded-full border-nature-200 hover:border-copper-500 hover:bg-copper-500/5"
                            >
                                <ShoppingCart className="w-4 h-4 text-nature-800" />
                                {cartCount > 0 && (
                                    <span className="absolute -top-2 -right-2 w-5 h-5 bg-copper-500 text-white text-xs rounded-full flex items-center justify-center cart-badge">
                                        {cartCount}
                                    </span>
                                )}
                            </Button>
                        </Link>

                        {/* Mobile Menu Button */}
                        <button
                            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                            className="md:hidden p-2 text-nature-800 hover:text-copper-500 transition-colors"
                            data-testid="mobile-menu-button"
                            aria-label="Toggle menu"
                        >
                            {mobileMenuOpen ? (
                                <X className="w-6 h-6" />
                            ) : (
                                <Menu className="w-6 h-6" />
                            )}
                        </button>
                    </div>
                </nav>
            </div>

            {/* Mobile Menu Dropdown */}
            {mobileMenuOpen && (
                <div className="md:hidden glass border-t border-nature-200">
                    <div className="max-w-7xl mx-auto px-6 py-4 space-y-3">
                        {navLinks.map((link) => (
                            <Link
                                key={link.to}
                                to={link.to}
                                onClick={() => setMobileMenuOpen(false)}
                                className="block py-2 text-nature-800 hover:text-copper-500 transition-colors font-body font-medium"
                                data-testid={`mobile-${link.testId}`}
                            >
                                {link.label}
                            </Link>
                        ))}
                    </div>
                </div>
            )}
        </header>
    );
};
